import { getAuthorizationHeader } from "@brandclub/common-ui";
import axios from "../../../utils/axios";

type Status = "success" | "error";

export interface VerifyContactEmailResponse {
  status: Status;
  errorMessage?: string;
}

export interface ResendEmailVerificationResponse {
  status: Status;
  errorMessage?: string;
}

/**
 * Resend email verification code to the user's email
 */
export const resendContactEmailVerificationCode =
  async (): Promise<ResendEmailVerificationResponse> => {
    const res = await axios.post<ResendEmailVerificationResponse>(
      "/profile/resendEmailVerificationCode",
      {},
      {
        headers: {
          ...(await getAuthorizationHeader()),
        },
      }
    );
    return res?.data;
  };

/**
 * Verify email with the provided verification code
 */
export const verifyContactEmail = async (req: {
  emailVerificationCode: string;
}): Promise<VerifyContactEmailResponse> => {
  const res = await axios.post<VerifyContactEmailResponse>(
    "/profile/verifyEmail",
    req,
    {
      headers: {
        ...(await getAuthorizationHeader()),
      },
    }
  );
  return res?.data;
};
